// Bannière cookies Shopify : retire « y compris Shopify, » du message (choix de la marque).
// La bannière est injectée après le chargement, d'où l'observateur ; il s'arrête dès qu'elle est traitée.
const cleanBanner = () => {
  const text = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
  if (!text) return false;
  for (const node of text.childNodes) {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent.replace(/,\s*y[\s ]+compris Shopify\s*,/, '');
    }
  }
  return true;
};

if (!cleanBanner()) {
  const observer = new MutationObserver(() => {
    if (cleanBanner()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 20000);
}
